// View-mode enum values, not user-facing copy — the i18n literal rule does not apply.
/* eslint-disable i18next/no-literal-string */
export const ANALYSIS_VIEW_MODE = {
  grid: 'grid',
  list: 'list',
} as const;
/* eslint-enable i18next/no-literal-string */

export type AnalysisViewMode = (typeof ANALYSIS_VIEW_MODE)[keyof typeof ANALYSIS_VIEW_MODE];

export interface ViewToggleProps {
  value: AnalysisViewMode;
  onChange: (value: AnalysisViewMode) => void;
}
